<template>
  <!-- App.vue -->

  <v-app>
    <!--v-app-bar app dense>
      <app-topbar></app-topbar>
    </v-app-bar>
    <v-navigation-drawer app permanent expand-on-hover v-show="!show">

      <app-sidebar class="sidebar"></app-sidebar>
    </v-navigation-drawer-->

    <!-- Sizes your content based upon application components -->
    <v-container>
      <v-dialog v-model="dialogPermission" max-width="60%">
        <!-- permission component-->
        <app-permission
          v-bind:permissionData="editedItem"
          @closeEditPermission="closeEditPermission($event)"
        ></app-permission>
      </v-dialog>
      <v-card>
        <v-card-title>
          <a @click="back()">Back </a> / {{ $route.params.name }}
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <v-btn color="success" dark class="mb-2" @click="editItem(item)">
            <v-icon left>mdi-plus</v-icon> เพิ่มหมวดหมู่ย่อย
          </v-btn>
        </v-card-title>

        <v-toolbar flat>
          <v-spacer></v-spacer>

          <!-- delete dialog -->
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="headline"
                >Are you sure you want to delete {{ editedItem.name }}'s category
                ?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="closeDelete">ยกเลิก</v-btn>
                <v-btn color="success" @click="deleteItemConfirm">ยืนยัน</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>

        <v-overlay :absolute="absolute" :value="responseStatus.alertStatus">
          <v-btn
            :color="responseStatus.color"
            @click="responseStatus.alertStatus = false"
          >
            {{ responseStatus.text }}
          </v-btn>
        </v-overlay>

        <v-data-table
:sort-by.sync="options.sortBy"
            :sort-desc.sync="options.sortDesc"

          :headers="headers"
          :items="category"
          :options.sync="options"
          :footer-props="{ 'items-per-page-options': [5, 15, 30, 50, 100, -1] }"
        >
          <template v-slot:item.status="{ item }">
            <v-switch
              v-model="item.status"
              label=""
              color="success"
              :value="item.status"
              hide-details
              @click="clickSwitch(item)"
            ></v-switch>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="editItem(item)"
              v-if="item.is_admin != 'Y'"
            >
              mdi-pencil
            </v-icon>
            <!--v-icon small class="mr-2" @click="listProducts(item._id)">
              mdi-format-list-checks
            </v-icon-->
            <v-icon small @click="deleteItem(item)" v-if="item.is_admin != 'Y'">
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data> </template>
        </v-data-table>

        <v-navigation-drawer v-model="dialog" app width="480px" temporary right>
          <v-card>
            <v-card-title>
              <v-icon @click="dialog = !dialog">mdi-close-circle</v-icon>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.name"
                      label="Category name"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" v-if="edit">
                    <v-select
                      :items="items_status"
                      label="Status"
                      v-model="editedItem.status"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn tile color="primary" @click="close"> ยกเลิก</v-btn>
              <v-btn tile color="success" @click="save"> ยืนยัน</v-btn>
            </v-card-actions>
          </v-card>
        </v-navigation-drawer>
      </v-card>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";

//import AppSideBar from "../menu/sideBarMenu";
//import AppTopBar from "../menu/topBarMenu";

export default {
  name: "SubCategory",
  components: {
    /*
"app-sidebar": AppSideBar,
    "app-topbar": AppTopBar,
*/
  },
  data() {
    return {
      closeInSec: 3000,
      absolute: true,
      dialog: false,
      dialogDelete: false,
      editedItem: {
        name: "",
        status: "",
      },
      show: false,
      responseStatus: {
        alertStatus: false,
      },
      defaultItem: {},
      editedIndex: -1,
      edit: false,
      term: null,
      search: "",
      payloadBody: {},
      api_uri: process.env.VUE_APP_LOYALTY_API_URI,
      totalItems: 0,
      options: { sortBy: "createdAt", sortDesc: true },
      category: [],
      //category: {},
      dialogPermission: false,
      items_status: ["Active", "Inactive"],
      headers: [
        {
          value: "name",
          text: "Name",
        },
        {
          value: "status",
          text: "Status", // this.$t("tables.headings.status")
        },

        {
          value: "actions",
          text: "Actions", // this.$t("tables.headings.actions")
        },
      ],
    };
  },
  computed: {
    categoryFilter() {
      console.log("computed");
      if (this.search.length > 0) {
        return this.Category.filter(() => {
          //return item.name.toLowerCase().startsWith(this.search.toLowerCase());
          this.readCategory().then((response) => {
            this.Category = response.data.filter((item) => {
              return item.category == this.$route.params.category;
            });
            this.totalItems = response.totalItems;
          });
        });
      } else {
        return this.Category;
      }
    },
    formTitle() {
      return this.editedIndex === -1 ? "เพิ่ม" : "แก้ไข";
    },
  },
  mounted() {
    //
    this.listCategory();
    //this.totalItems = -1;
  },
  created() {
    //this.initialize();
  },
  methods: {
    clickSwitch(item) {
      //console.log(item);
      console.log(item);
      this.editedIndex = this.category.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.edit = this.editedIndex !== -1 ? true : false;
      this.save();
    },
    listProduct(_id) {
      console.log(_id);
    },

    listCategory() {
      this.readCategory().then((response) => {
        this.category = response.data.filter((item) => {
          return item.category == this.$route.params.category;
        });
        this.totalItems = response.totalItems;
      });
    },

    back() {
      this.$router.go(-1);
    },

    getColor(status) {
      //console.log(status);
      if (status == "Inactive") return "red";
      else return "green";
    },
    click(item, row) {
      console.log(item);
      console.log(row);
    },
    readCategory() {
      const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        this.payloadBody = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),

          category: this.$route.params.category,
          page: this.options.page - 1,
          limit: this.options.itemsPerPage,
          filter: this.search,
        };
        return axios
          .get(url + "/v1/subcategory/list", {
            params: this.payloadBody, // need to change
          })
          .then((response) => {
            return response.data;
          });
      } catch (err) {
        this.responseStatus = {
          status: "Error",
          code: 500,
          message: err,
        };
      }
    },
    editItem(item) {
      this.editedIndex = this.category.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.edit = this.editedIndex !== -1 ? true : false;
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.category.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    editPermission(item) {
      //console.log(item)
      this.dialogPermission = true;
      this.editedItem = Object.assign({}, item);
    },

    async deleteItemConfirm() {
      const url = process.env.VUE_APP_LOYALTY_API_URI;
      try {
        this.payloadBody = {
          createdBy: sessionStorage.getItem("email"),
          updatedBy: sessionStorage.getItem("email"),
          custId: sessionStorage.getItem("custId"),

          id: this.editedItem._id,
        };

        await axios
          .delete(
            url + "/v1/subcategory/" + this.editedItem._id,
            this.payloadBody, // need to change
            {
              headers: {
                // Overwrite Axios's automatically set Content-Type
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            if (response.data.ok == 1) {
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
              };
            }
          });
        //console.log(this.category);
        if (this.responseStatus.code == 0) {
          this.category.splice(this.editedIndex, 1);
          //this.readCategory()
          this.listCategory();
          //this.totalItems--;
        }
      } catch (err) {
        return (this.responseStatus = {
          status: "Error",
          code: 500,
          color: "red",
          type: "error",
          text: err,
          alertStatus: true,
        });
      }

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.edit = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, {});
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, {});
        this.editedIndex = -1;
      });
    },
    // timeout close overlay
    closeInTime(sec) {
      setTimeout(() => {
        this.responseStatus.alertStatus = false;
      }, sec);
    },

    async save() {
      if (this.editedIndex > -1) {
        console.log("update");
        const url = process.env.VUE_APP_LOYALTY_API_URI;
        try {
          this.payloadBody = {
            createdBy: sessionStorage.getItem("email"),
            updatedBy: sessionStorage.getItem("email"),
            custId: sessionStorage.getItem("custId"),

            name: this.editedItem.name,
            status: this.editedItem.status,
            id: this.editedItem._id,
          };
          console.log(this.payloadBody);
          await axios
            .put(
              url + "/v1/subcategory/update",
              this.payloadBody, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              //console.log(response.data)
              //this.category = response.data;
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data,
              };
              //console.log(this.responseStatus)
              //this.category = response.data;
              if (response.data.nModified == 1) {
                Object.assign(this.category[this.editedIndex], this.editedItem);
              } else {
                // do something
              }
            });

          //console.log(this.category);
          //console.log("updated");
        } catch (err) {
          //console.log(err)
          //return err;
          return (this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          });
        }
      } else {
        const url = process.env.VUE_APP_LOYALTY_API_URI;
        try {
          this.payloadBody = {
            createdBy: sessionStorage.getItem("email"),
            updatedBy: sessionStorage.getItem("email"),
            custId: sessionStorage.getItem("custId"),

            name: this.editedItem.name,
            category: this.$route.params.category,
            categoryName: this.$route.params.name,
            status: "Active",
            //custId: sessionStorage.getItem("custId"),
          };
          await axios
            .post(
              url + "/v1/subcategory/create",
              this.payloadBody, // need to change
              {
                headers: {
                  // Overwrite Axios's automatically set Content-Type
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              this.responseStatus = {
                status: "Success",
                code: 0,
                color: "green",
                type: "success",
                text: "บันทึกสำเร็จ",
                alertStatus: true,
                data: response.data,
              };
              this.totalItems++;
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (err) {
          return (this.responseStatus = {
            status: "Error",
            code: 500,
            color: "red",
            type: "error",
            text: err,
            alertStatus: true,
          });
        }
      }
      console.log("saved");
      this.listCategory();
      this.close();
    },
  },

  watch: {
    // options: {
    //   handler() {
    //     //console.log(this.options);
    //     this.payloadBody = {
    //createdBy: sessionStorage.getItem("email"),
    // updatedBy: sessionStorage.getItem("email"),
    // custId: sessionStorage.getItem("custId"),

    //       custId: sessionStorage.getItem("custId"),
    //       page: this.options.page - 1,
    //       limit: this.options.itemsPerPage,
    //     };

    //     this.readCategory().then((response) => {
    //       this.category = response.data;
    //       this.totalItems = response.totalItems;
    //     });
    //   },
    //   deep: true,
    // },
    editPermission: {
      handler() {
        console.log(this.editPermission);
      },
    },

    search: {
      handler() {
        console.log("search");
        // this.readCategory().then((response) => {
        //   this.category = response.data;
        //   this.totalItems = response.totalItems;
        // });
      },
    },
    dialog(val) {
      //console.log(val);
      val || this.close();
    },
    dialogDelete(val) {
      //console.log(val);
      val || this.closeDelete();
    },
    totalItems: {
      handler() {
        console.log("totalItems");
        //console.log(this.totalItems)
        // this.readCategory().then((response) => {
        //   this.category = response.data;
        //   this.totalItems = response.totalItems;
        // });
      },
    },
    responseStatus: {
      handler() {
        if (this.responseStatus.alertStatus === true) {
          this.closeInTime(this.closeInSec);
        }
      },
    },
  },
};
</script>
